import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-yes-no',
  templateUrl: './yes-no.component.html',
  styleUrls: ['./yes-no.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class YesNoComponent {
  private _actionName?: string;
  private _cancelName?: string;

  get actionName(): string { return this._actionName ?? this.translateService.instant('COMMON.save'); }
  @Input() set actionName(value: string) { this._actionName = value; }
  get cancelName(): string { return this._cancelName ?? this.translateService.instant('COMMON.cancel'); }
  @Input() set cancelName(value: string) { this._cancelName = value; }
  @Input() actionIcon?: string;
  @Input() disableReason = false;
  @Input() actionType = 'submit';

  @Output() action = new EventEmitter();
  @Output() cancel = new EventEmitter();

  constructor(private translateService: TranslateService) { }
}
